import {CdkScrollableModule, ScrollingModule} from '@angular/cdk/scrolling';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatAutocompleteModule} from '@angular/material/autocomplete';

import {MatButtonModule} from '@angular/material/button';
import {MatChipsModule} from '@angular/material/chips';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTooltipModule} from '@angular/material/tooltip';

import {RouterModule} from '@angular/router';

import {TagModule} from '@app/tag/tag.module';
import {NgScrollbarModule} from 'ngx-scrollbar';
import {InspectorModule} from '../inspector/inspector.module';
import {UploadModule} from '../upload/upload.module';
import {AssetListComponent} from './asset-list/asset-list.component';
import {AssetThumbnailComponent} from './asset-thumbnail/asset-thumbnail.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        UploadModule,
        InspectorModule,
        MatIconModule,
        MatButtonModule,
        MatToolbarModule,
        MatInputModule,
        MatSidenavModule,
        MatChipsModule,
        MatProgressSpinnerModule,
        MatAutocompleteModule,
        CdkScrollableModule,
        ScrollingModule,
        NgScrollbarModule,
        TagModule,
        MatTooltipModule,
        AssetListComponent,
        AssetThumbnailComponent,
    ],
    exports: [AssetListComponent],
})
export class AssetModule {}
